import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import {
  PackageSizeGrid,
  ColumnHeading,
  StyledTextField,
  PackageSizeError,
  StyledWrapper,
} from './package-size-and-weight.component.styles'
import { SmallText } from 'ggx-componentlibrary/design/typography/typography.styles'

const PackageSize = ({
  length,
  width,
  height,
  package_size_error: packageSizeError,
}) => {
  const [t] = useTranslation()

  const allInputsTouched =
    length.meta.touched && width.meta.touched && height.meta.touched
  const allInputsDirty =
    length.meta.dirty && width.meta.dirty && height.meta.dirty

  const error =
    (allInputsTouched || allInputsDirty) && packageSizeError.meta.error

  const preventEnteringDecimalOrHyphen = event => {
    if (event.key === '-' || event.key === '.') {
      event.preventDefault()
    }
  }

  return (
    <StyledWrapper>
      <PackageSizeGrid>
        <ColumnHeading>{t('label__length')}</ColumnHeading>
        <ColumnHeading>{t('label__width')}</ColumnHeading>
        <ColumnHeading>{t('label__height')}</ColumnHeading>
      </PackageSizeGrid>
      <PackageSizeGrid>
        <StyledTextField
          showErrorWhenDirty
          data-testid="package-size-length-field"
          showSuffix={t('suffix__cm')}
          input={length.input}
          meta={length.meta}
          type="number"
          onKeyPress={preventEnteringDecimalOrHyphen}
        />
        <StyledTextField
          showErrorWhenDirty
          data-testid="package-size-width-field"
          showSuffix={t('suffix__cm')}
          input={width.input}
          meta={width.meta}
          type="number"
          onKeyPress={preventEnteringDecimalOrHyphen}
        />
        <StyledTextField
          showErrorWhenDirty
          data-testid="package-size-height-field"
          showSuffix={t('suffix__cm')}
          input={height.input}
          meta={height.meta}
          type="number"
          onKeyPress={preventEnteringDecimalOrHyphen}
        />
      </PackageSizeGrid>
      {error && <PackageSizeError>{error}</PackageSizeError>}
      <SmallText typographyStyles="mt-xs mb-m">
        {t('helper__lwh_single_limit', { singleSideDimension: 120 })} <br />
        {t('helper__lwh_sum_limit', { total: 180 })}
      </SmallText>
    </StyledWrapper>
  )
}

PackageSize.propTypes = {
  length: PropTypes.object,
  width: PropTypes.object,
  height: PropTypes.object,
  package_size_error: PropTypes.object,
}

export { PackageSize }
